import type { MailboxInfo } from "owa-client-types";
import { isServiceRequestSupportedForMailbox } from "owa-service/lib/utils/isServiceRequestSupportedForMailbox";
import { isOfflinePeopleDataViaPDVEnabled, type PDVStateDetails, } from "./isOfflinePeopleDataViaPDVEnabled";
import { isOfflineSyncEnabled } from "./isOfflineSyncEnabled";

/**
 * Returns true if Online Sync is enabled for the given mailbox and it supports service requests.
 * If isOfflineSyncEnabled() is true, the isOnlineSyncEnabled() will always be false and vis versa.
 * But both isOnlineSyncEnabled() and isOfflineSyncEnabled() can be false.
 */
export function isOnlineSyncEnabled(mailboxInfo: MailboxInfo): boolean {
    if (!isServiceRequestSupportedForMailbox(mailboxInfo)) {
        return false;
    }
    
    try {
        // Offline sync and online sync are mutually exclusive. If offline sync is enabled, online sync is not possible.
        if (isOfflineSyncEnabled(mailboxInfo)) {
            return false;
        }
        
        const pdvStateDetails: PDVStateDetails = {};
        if (isOfflinePeopleDataViaPDVEnabled(mailboxInfo, pdvStateDetails) &&
            // peo-offline-via-pdv is true
            pdvStateDetails.isPdvInMemoryEnabled &&
            // isOfflineSyncEnabled() is false or other PDV conditions are false
            !pdvStateDetails.isOfflinePeopleDataViaPDVEnabledAllUp // &&
        ) {
            return true;
        }
    }
    catch { }
    return false;
}

/**
 * Returns true if online sync is possible for the given app.
 */
export function isOnlineSyncEnabledForApp(app: string): boolean {
    switch (app) {
        case "PeopleNew":
            return true;
        default:
            return false;
    }
}
